import React, { Component } from 'react';


class EditPageContentStoreItem extends Component {
    constructor() {
        super();
        this.id= "";
    }

    handleRemoveStore(e){
        e.preventDefault();
        this.props.callBackRemoveStore(this.id);
    }

    componentWillMount(){
        this.id= this.props.id;
    }

    render() {
        return (
            <div className="editAppStoreItem" >
                <div className="editAppStoreItem-icon">
                    <a href="/" onClick={this.handleRemoveStore.bind(this)}><i className="fas fa-times-circle"></i></a>
                </div>
                <div className="editAppStoreItem-link">
                    <a href="/">{this.props.id} - {this.props.url}</a>
                </div>
            </div>
        );

    }
}

export default EditPageContentStoreItem;



// WEBPACK FOOTER //
// ./src/adm/componentes/EditPageContentStoreItem.js